import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom';
import { LandingPage } from '../pages/Landing/index';
import { toBool } from '../utils/vite-env/toBool';
import { CookiePolicyPage } from '../pages/CookiePolicy/CookiePolicy';
import { TermsAndConditionsPage } from '../pages/TermsAndConditions/TermsAndConditionsPage';
import Layout from '../Layout';

const { VITE_APP_PATH, VITE_MAINTENANCE_MODE_ENABLED, VITE_PR_ID } = import.meta.env;

const routes = [
  { path: '/', Component: LandingPage },
  { path: '/cookies', Component: CookiePolicyPage },
  { path: '/terms', Component: TermsAndConditionsPage },
];

const appPath =
  `${VITE_PR_ID ? `/${VITE_PR_ID}` : ''}${VITE_APP_PATH ? `/${VITE_APP_PATH}` : VITE_PR_ID ? '' : '/'}`.trim();

export const AppRoutes = () => {
  const maintenanceModeEnabled = toBool(VITE_MAINTENANCE_MODE_ENABLED);

  return createBrowserRouter(
    createRoutesFromElements(
      <Route element={<Layout />}>
        {maintenanceModeEnabled ? (
          <Route path="*" Component={() => <div>Maintenance Mode Enabled</div>} />
        ) : (
          routes.map(({ path, Component }) => (
            <Route key={path} path={path} Component={Component} />
          ))
        )}
      </Route>,
    ),
    { basename: appPath },
  );
};
